import { useEffect, useState } from "preact/hooks";

const ALT_HINT_DELAY_MS = 550;

export function useAltHintVisibility() {
  const [showAltHints, setShowAltHints] = useState(false);

  useEffect(() => {
    let timeoutId = null;

    function clearHintTimer() {
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
        timeoutId = null;
      }
    }

    function hideHints() {
      clearHintTimer();
      setShowAltHints(false);
    }

    function handleKeyDown(event) {
      if (event.key === "Alt" && !event.repeat) {
        event.preventDefault();
        clearHintTimer();
        timeoutId = window.setTimeout(() => {
          setShowAltHints(true);
          timeoutId = null;
        }, ALT_HINT_DELAY_MS);
        return;
      }

      if (event.altKey && event.key !== "Alt") {
        hideHints();
      }
    }

    function handleKeyUp(event) {
      if (event.key === "Alt") {
        event.preventDefault();
        hideHints();
      }
    }

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    window.addEventListener("blur", hideHints);

    return () => {
      clearHintTimer();
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
      window.removeEventListener("blur", hideHints);
    };
  }, []);

  return showAltHints;
}
